<template>
  <div class="tabList">
    <div class="tab-all">
      <van-tabs line-width="0" @click="tabSelect">
        <van-tab title-class="all-item" :title-style="{ color: tabIndex == index ? '#0FBF70' : '' }"
          v-for="(item, index) in tabList" :key="index" :title="item.tabName + '（' + item.tabNum + '）'">
        </van-tab>
      </van-tabs>
    </div>
    <div class="tab-status">
      <van-tabs class="status-tabs" background="transparent" line-width="0" @click="tabStatusSelect">
        <van-tab title-class='status-tab' v-for="(item, index) in tabStatusList" :key="index">
          <template #title>
            <div>
              <p class="status-item" :class="{ select: tabStatusIndex == index }">{{ item.tabName }}</p>
              <div class="pop" v-if="item.tabStatus == 50">返现金</div>
            </div>
          </template>
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>
<script>
import { Tab, Tabs } from 'vant';

export default {
  name: 'tabList',
  props: {
    tabList: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  components: {
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
  },
  data() {
    return {
      tabIndex: 0,
      tabStatusIndex: 0,
      currentProjectId: 0,
      tabStatusList: [
        {
          tabName: '全部',
          tabStatus: 0,
          tabLabel: 0,
        },
        {
          tabName: '快过期',
          tabStatus: 0,
          tabLabel: 2,
        },
        {
          tabName: '未生效',
          tabStatus: 2,
          tabLabel: 3,
        },
        {
          tabName: '已使用',
          tabStatus: 1,
          tabLabel: 0,
        },
        {
          tabName: '已过期',
          tabStatus: 3,
          tabLabel: 0,
        },
        // {
        //   tabName: '可回收',
        //   tabStatus: 50,
        //   tabLabel: 0,
        // },
      ],
    };
  },
  watch: {
    tabList(newVal) {
      if (newVal.length > 0) {
        this.tabList.forEach((item) => {
          switch (item.tabName) {
            // case 'allCount':
            //   item.tabName = '全部';
            //   item.projectId = 0;
            //   break;
            case 'trainCount':
              item.tabName = '火车票';
              item.projectId = 1;
              break;
            case 'airCount':
              item.tabName = '机票';
              item.projectId = 2;
              break;
            case 'hotelCount':
              item.tabName = '酒店';
              item.projectId = 3;
              break;
            case 'sceneryCount':
              item.tabName = '景区';
              item.projectId = 4;
              break;
            case 'carCount':
              item.tabName = '用车';
              item.projectId = 5;
              break;
            case 'busCount':
              item.tabName = '汽车票';
              item.projectId = 6;
              break;
            case 'vacation':
              item.tabName = '度假';
              item.projectId = 42;
              break
            // case 'shipCount':
            //   item.tabName = '船票';
            //   item.projectId = 7;
            //   break;
            // case 'taxiCount':
            //   item.tabName = '租车';
            //   item.projectId = 8;
            //   break;
            // case 'mallCount':
            //   item.tabName = '商城';
            //   item.projectId = 9;
            //   break;
            // case 'restaurantCount':
            //   item.tabName = '餐饮';
            //   item.projectId = 10001;
            //   break;
            // case 'otherCount':
            //   item.tabName = '其他';
            //   item.projectId = 100;
            //   break;
            // case 'goldCount':
            //   item.tabName = '微信立减金';
            //   item.type = 1;
            //   break;
            // case 'commonCount':
            //   item.tabName = '通用';
            //   item.projectId = 1000;
            //   break;
            default:
              break;
          }
        });
      }
    },
  },
  created() { },
  mounted() { },
  destroyed() { },
  methods: {
    tabSelect(index) {
      this.tabIndex = index;
      const item = this.tabList[index];
      this.currentProjectId = item.projectId;
      this.$emit('tabSelect', this.currentProjectId || 1, item.type || 0, item.tabName);
    },
    tabStatusSelect(index) {
      this.tabStatusIndex = index;
      const item = this.tabStatusList[index];
      this.$emit('tabStatusSelect', this.currentProjectId || 1, item.tabStatus || 0, item.tabLabel || 0, item.tabName);
    }
  },
};
</script>
<style lang="less">
.tabList {
  position: fixed;
  top: 0;
  width: 375px;
  height: 92px;
  background: #ffffff;
  z-index: 888;

  .all-item {
    font-size: 14px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #333;
    line-height: 20px;
    flex-shrink: 0;
    position: relative;
  }

  .status-tabs {
    
  }
  .status-tab {
    // margin-right: -10px;
  }

  .status-item {
    padding: 0 13px;
    background: #f7f7f7;
    border-radius: 13px;
    height: 27px;
    line-height: 27px;
    text-align: center;
    font-size: 12px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #333;
  }

  .status-item.select {
    height: 26px;
    line-height: 26px;
    color: #0fbf70;
    border: 1px solid #0fbf70;
  }

  .pop {
    position: absolute;
    right: 10px;
    top: 0;
    width: 33px;
    height: 15.5px;
    background: url('https://file.40017.cn/appresource/image/tRedpack/pop_bg.png') no-repeat;
    background-size: 100% 100%;
    font-family: PingFangSC-SNaNpxibold;
    font-weight: 600;
    font-size: 8px;
    color: #FFFFFF;
    line-height: 14px;
    text-align: center;
  }
}
</style>